import { gql } from '@apollo/client'

export const PICTURES_LIST = gql`
  fragment PicturesList on Picture {
    url
    fileId
    width
    height
    cloudinary {
      publicId
      format
      version
    }
  }
`

export const ASSETS_LIST = gql`
  fragment AssetsList on AssetsList {
    assetType
    shadowIntensity
    asset {
      ...PicturesList
    }
  }
  ${PICTURES_LIST}
`
